export default __webpack_public_path__ + "0e3938868f03f4652b67c8070fb6c063.svg";